module.exports = __webpack_public_path__ + "assets/webgl/Ceramic_materialParams.1001.jpg.dxt.21f5cfca.ktx";